import MobileDetect from 'mobile-detect'
import NoSleep from 'nosleep.js';

const state = {
  ready: false,
  viewport: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  skipTo: null,
  device: new MobileDetect(window.navigator.userAgent),
  noSleep: new NoSleep(),
  noSleepEnable: false,
};

const mutations = {
  SET_READY(state) {
    state.ready = true;
  },
  
  RESIZE(state) {
    state.viewport = {
      width: window.outerWidth || window.innerWidth,
      height: window.outerHeight || window.innerHeight
    }

    state.device = new MobileDetect(window.navigator.userAgent);
  },

  SKIP_TO(state, value) {
    if (process.env.NODE_ENV === 'development') state.skipTo = value.charAt(0).toUpperCase() + value.slice(1)
  },

  ENABLE_NO_SLEEP(state) {
    if (!state.noSleepEnable) {
      state.noSleep.enable();
      state.noSleepEnable = true;
    }
  }
};

const actions = {
  INIT({commit}, locale) {
    commit('I18n/SET_LOCALE', locale, {root:true});

    window.addEventListener('resize', () => {
      commit('RESIZE');
    });

    window.addEventListener('orientationchange', () => {
      window.dispatchEvent(new Event("resize"));
    });
  },
};

const getters = {
  ready: state => state.ready,
  viewport: state => state.viewport,
  skipTo: state => {
    return process.env.NODE_ENV === 'development' ? state.skipTo : null
  },
  isMobile: state => state.device.mobile() !== null,
  isTablet: state => state.viewport.width >= 768 && state.viewport.width < 1024,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
